// extracted by mini-css-extract-plugin
export default {"customInformationBox":"UUtBd7073BTDMfhn8vLQ","upgradeLink":"P6N4ksPsT5AizE6_5pjI"};